import type { SelectInputOption } from "../inputs/SelectInput";
import type { Theme } from "./types";
import { GALAXY_FONT } from "./typography";
import { GALAXY_DARK_COLOR } from "./variants/dark";
import { GALAXY_LIGHT_COLOR } from "./variants/light";

export const GALAXY_THEME_STORAGE_KEY = "galaxy:theme";

export enum GalaxyTheme {
  SYSTEM = "SYSTEM",
  DARK = "DARK",
  LIGHT = "LIGHT",
}

export const GALAXY_DARK_THEME: Theme = {
  color: GALAXY_DARK_COLOR,
  font: GALAXY_FONT,
};

export const GALAXY_LIGHT_THEME: Theme = {
  color: GALAXY_LIGHT_COLOR,
  font: GALAXY_FONT,
};

export const GALAXY_THEME_OPTIONS: SelectInputOption[] = [
  {
    id: GalaxyTheme.SYSTEM,
    label: "System",
    value: GalaxyTheme.SYSTEM,
  },
  {
    id: GalaxyTheme.DARK,
    label: "Dark",
    value: GalaxyTheme.DARK,
  },
  {
    id: GalaxyTheme.LIGHT,
    label: "Light",
    value: GalaxyTheme.LIGHT,
  },
];

export const GALAXY_THEME_MAP: Record<Exclude<GalaxyTheme, GalaxyTheme.SYSTEM>, Theme> = {
  [GalaxyTheme.DARK]: GALAXY_DARK_THEME,
  [GalaxyTheme.LIGHT]: GALAXY_LIGHT_THEME,
};

export const DEFAULT_THEME = GALAXY_DARK_THEME;
